import(/* webpackMode: "eager", webpackExports: ["ModuleClientLayout"] */ "/codebuild/output/src2340012390/src/web-app/packages/webapp/app/cw/[subdomain]/(app)/questboard/[moduleId]/_layouts/ModuleClientLayout.tsx");
